import { useState } from 'react';

const useToggle = (initialState=false) => {
    const [state, setState] = useState(initialState);
    const toggle = () => setState(!state);
    return [state, toggle];
}

const useLogic = (props) => {
    const {quickFilters=[], filters=[], onFilterSelect} = props;
    const [isDropdownOpen, toggleDropdown] = useToggle(false);
    return {
        filters,
        quickFilters,
        onFilterSelect,
        isDropdownOpen,
        toggleDropdown,
    }
}

export default useLogic;